import ReduxActions from '../../constants/redux-actions';
import AppPermissions from '../../models/app-permissions';
import VoicemailSettings from '../../models/voicemail-settings';
import PresenceActivity from './../../models/presence-activity';
import UserPresenceMapping from './../../models/user-presence-mapping';
import FeatureFlags from '../../models/feature-flags';

function acSetPermissions(appPermissions: AppPermissions) {
  return {
    type: ReduxActions.SET_PERMISSIONS,
    data: { appPermissions: appPermissions },
  };
}

function acSetTestUserList(users: string[]) {
  return {
    type: ReduxActions.SET_TEST_USERS,
    data: { testUsers: users },
  };
}

function acSetFeatureFlags(featureFlags: FeatureFlags) {
  return {
    type: ReduxActions.SET_FEATURE_FLAGS,
    data: { featureFlags: featureFlags },
  };
}

function acSetPresenceActivityList(presenceActivities: PresenceActivity[]) {
  return {
    type: ReduxActions.SET_PRESENCE_ACTIVITIES,
    data: { presenceActivities: presenceActivities },
  };
}

function acSetPresenceActivitiesMapping(userPresenceMappings: UserPresenceMapping[]) {
  return {
    type: ReduxActions.SET_USER_PRESENCE_MAPPINGS,
    data: { userPresenceMappings: userPresenceMappings },
  };
}

function acSetPresenceActivitiesDefaultMapping(userPresenceDefaultMappings: UserPresenceMapping[]) {
  return {
    type: ReduxActions.SET_USER_PRESENCE_DEFAULT_MAPPINGS,
    data: { userPresenceDefaultMappings: userPresenceDefaultMappings },
  };
}

function acAdminRole(isAdmin: boolean) {
  return {
    type: ReduxActions.SET_ADMIN_ROLE,
    data: { isAdmin: isAdmin },
  };
}

function acGraphUrls(adminUrl: string, userUrl: string) {
  return {
    type: ReduxActions.SET_GRAPH_URLS,
    data: {
      adminUrl: adminUrl,
      userUrl: userUrl,
    },
  };
}

function acSetVoicemailSettings(settings: VoicemailSettings) {
  return {
    type: ReduxActions.SET_VOICEMAIL_SETTINGS,
    data: {
      voicemailSettings: settings,
    },
  };
}

export {
  acSetPermissions,
  acSetFeatureFlags,
  acSetPresenceActivityList,
  acSetPresenceActivitiesMapping,
  acSetPresenceActivitiesDefaultMapping,
  acAdminRole,
  acGraphUrls,
  acSetTestUserList,
  acSetVoicemailSettings,
};
